module.exports = __webpack_public_path__ + "static/media/IOTSU_S2R_L02.2334256e.jpg";